import React from 'react';
import { pricingData } from '../mock';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ChevronRight } from 'lucide-react';

const PricingTable = ({ title, items }) => {
  return (
    <div className="bg-zinc-900 border border-zinc-800 overflow-hidden">
      <div className="bg-red-900 p-6">
        <h3 className="text-2xl font-black text-white uppercase tracking-wide">{title}</h3>
        <p className="text-red-200 text-sm mt-1">All piercings include the jewelry</p>
      </div>
      <div className="p-6">
        <div className="space-y-3">
          {items.map((item, index) => (
            <div key={index} className="flex justify-between items-start py-3 border-b border-zinc-800 last:border-0">
              <div className="flex-1">
                <p className="text-zinc-100 font-semibold">{item.name}</p>
                {item.special && (
                  <p className="text-zinc-500 text-sm mt-1">{item.special}</p>
                )}
              </div>
              <div className="text-right">
                <p className="text-zinc-100 font-bold text-lg">
                  {typeof item.price === 'number' ? `$${item.price}` : item.price}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const Pricing = () => {
  return (
    <div className="min-h-screen bg-zinc-950 py-20 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-black mb-4 text-zinc-100">PRICING</h1>
          <p className="text-zinc-400 text-lg max-w-2xl mx-auto">
            Transparent pricing with no hidden fees. All piercings include high-quality jewelry.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <PricingTable title="Oral Piercings" items={pricingData.oral} />
          <PricingTable title="Facial Piercings" items={pricingData.facial} />
          <PricingTable title="Ear & Cartilage Piercings" items={pricingData.ear} />
          <PricingTable title="Body Piercings" items={pricingData.body} />
        </div>

        <div className="bg-zinc-900 border border-zinc-800 p-8 text-center">
          <h3 className="text-2xl font-black text-zinc-100 mb-4">READY TO BOOK?</h3>
          <p className="text-zinc-400 mb-6">Schedule your appointment today</p>
          <Link to="/booking">
            <Button size="lg" className="bg-red-800 hover:bg-red-700 text-white px-8 py-4 font-bold tracking-wide transition-all duration-300 hover:scale-105">
              Book Appointment
              <ChevronRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Pricing;